import React from "react";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const FAQSection = () => {
  const faqs = [
    {
      question: "What are the Responsibilities of Our Caregivers?",
      answer: [
        "Help with daily activities and mobility",
        "Maintain patient hygiene and cleanliness",
        "Diaper change and sponge bath",
        "Feeding assistance",
        "Safety monitoring and support",
      ],
    },
    {
      question: "Will Caregivers Help with Household Chores?",
      answer: `Our caregivers are focused on patient care. Household chores like floor cleaning, washing clothes, mopping, cooking, washing patient clothes by hand, injection or any surgical procedures, domestic work, and preparing food for family are not part of their duty.`,
    },
  ];

  return (
    <Box sx={{ padding: "5rem 2rem", backgroundColor: "#f9f9f9" }}>
      <Typography variant="h4" component="h2" align="center" gutterBottom>
        Frequently Asked Questions
      </Typography>
      <Box sx={{ maxWidth: "800px", margin: "0 auto" }}>
        {faqs.map((faq, index) => (
          <Accordion key={index}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6">{faq.question}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {Array.isArray(faq.answer) ? (
                <ul>
                  {faq.answer.map((item, idx) => (
                    <li key={idx}>
                      <Typography>{item}</Typography>
                    </li>
                  ))}
                </ul>
              ) : (
                <Typography>{faq.answer}</Typography>
              )}
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Box>
  );
};

export default FAQSection;
